import assign from 'lodash/assign';
import { FormActionTypes } from '../actions/form-actions';

export default (state = {}, { type, payload }) => {
  switch (type) {
    case FormActionTypes.SUBMIT_FORM: {
      return assign({}, state, {
        [payload.key]: {
          ...payload,
          loading: true,
          failed: false,
          success: false,
          error: null
        }
      });
    }
    case FormActionTypes.SUBMIT_FORM_COMPLETE: {
      const formKey = payload.key;
      return assign({}, state, {
        [formKey]: {
          ...state[formKey],
          loading: false,
          failed: false,
          success: true,
          error: null
        }
      });
    }
    case FormActionTypes.SUBMIT_FORM_ERROR: {
      const formKey = payload.key;
      return assign({}, state, {
        [formKey]: {
          ...state[formKey],
          loading: false,
          failed: true,
          success: false,
          error: payload.error
        }
      });
    }
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/forms-reducer.js